import { FormikStep, typedMemo } from "src/types";
import {
  Button,
  ModalInfo,
  Separator,
  StrongTranslationString,
} from "src/ui/widgets";
import { useDataEntryWrapper } from "./data-entry-wrapper.hook";
import { MAX_DATA_ENTRY_STEP } from "src/config";
import { DataEntryVehicleStep } from "./data-entry-vehicle-step/data-entry-vehicle-step";
import { DataEntryAccidentStep } from "./data-entry-accident-step/data-entry-accident-step";
import { RightArrowIcon } from "src/assets";
import { DataEntrySignatureAStep } from "./data-entry-signature-a-step/data-entry-signature-a-step";

export const DataEntryWrapper = typedMemo(() => {
  const {
    formikCAI,
    validationSchema,
    responsabilityModalVisibility,
    responsabilityModalMessage,
    currentStep,
    t,
    onGoBackClick,
    handleFormiksubmit,
    hideResponsabilityModalVisibility,
    updateAccidentDataDraft,
  } = useDataEntryWrapper();

  const TopBody = (
    <div>
      {currentStep != FormikStep.VEHICLE_A && (
        <Button
          flavor="transparentAccentBack"
          text={t("commons.back")}
          classes="mb-2 p-0"
          classesText="text-uppercase label-l--500"
          onPress={onGoBackClick}
        />
      )}
      <div className="title-l--600">{t("data_entry.title")}</div>
      <div className="subtitle-xs mt-1 mb-2 c-light">
        {t("data_entry.subtitle")}
      </div>
      <div className="subtitle-s">
        {t("data_entry.step_title", {
          act_step: currentStep + 1,
          max_step: MAX_DATA_ENTRY_STEP,
        })}
      </div>
      <Separator classes="my-3" />
    </div>
  );

  const Content = (
    <div>
      {currentStep == FormikStep.VEHICLE_A && (
        <DataEntryVehicleStep
          step={currentStep}
          formik={formikCAI}
          validationSchema={validationSchema}
          formikVehicleValues={formikCAI.values.vehicleA}
          formikVehicleTouched={formikCAI.touched.vehicleA}
          formikVehicleErrors={formikCAI.errors.vehicleA}
        />
      )}
      {currentStep == FormikStep.VEHICLE_B && (
        <DataEntryVehicleStep
          step={currentStep}
          formik={formikCAI}
          validationSchema={validationSchema}
          formikVehicleValues={formikCAI.values.vehicleB}
          formikVehicleTouched={formikCAI.touched.vehicleB}
          formikVehicleErrors={formikCAI.errors.vehicleB}
        />
      )}
      {currentStep == FormikStep.ACCIDENT_DATA && (
        <DataEntryAccidentStep
          formik={formikCAI}
          validationSchema={validationSchema}
          formikAccidentValues={formikCAI.values.accidentData}
          formikAccidentTouched={formikCAI.touched.accidentData}
          formikAccidentErrors={formikCAI.errors.accidentData}
        />
      )}
      {currentStep == FormikStep.SIGNATURE_A && (
        <DataEntrySignatureAStep formik={formikCAI} />
      )}
    </div>
  );

  const Bottom = (
    <>
      {currentStep !== FormikStep.SIGNATURE_A && (
        <div className="d-flex flex-column jusfify-content-center">
          <Separator classes="mt-5 my-4" />

          <div className="mx-auto my-auto">
            <Button
              flavor="primary"
              iconLeft={RightArrowIcon}
              classes="px-5"
              text={t("commons.continue")}
              classesText="text-uppercase label-l--500"
              onPress={handleFormiksubmit}
            />
          </div>
        </div>
      )}
    </>
  );

  const ResponsabilityModal = (
    <ModalInfo
      visible={responsabilityModalVisibility}
      icon=""
      title={t(
        "data_entry.accident_step.section_accident_circumstances_labels.resp_title",
      )}
      body={
        <div>
          <p className="mb-4 mt-3 label-xxl">
            {t(
              "data_entry.accident_step.section_accident_circumstances_labels.resp_body_1",
            )}
          </p>
          <p className="mb-5 mt-3 label-xxl">
            <StrongTranslationString
              i18nKey={
                "data_entry.accident_step.section_accident_circumstances_labels.resp_body_2"
              }
              param={{ resp: responsabilityModalMessage }}
              color="#000000"
            />
          </p>
        </div>
      }
      confirmText={t("commons.proceed")}
      notConfirmText={t("commons.review_answers")}
      onNotConfirm={hideResponsabilityModalVisibility}
      onClose={hideResponsabilityModalVisibility}
      onConfirm={updateAccidentDataDraft}
    />
  );

  return (
    <div>
      {TopBody}
      <form>
        <main>{Content}</main>
        {Bottom}
      </form>
      {ResponsabilityModal}
    </div>
  );
});
